<block-ui [name]="'app-main'" [delayStart]="10" [delayStop]="500" [message]="'Loading, please wait...'">

  <router-outlet></router-outlet>
  
  
</block-ui>
<!--<notifier-container></notifier-container>-->
